<template>
  <div class="dialog">
    <div class="dialog-hd">
      <template v-if="title === '计划选择'">
        <el-form inline>
          <el-form-item>
            <el-select
              v-model="plan.mediaIds"
              multiple
              collapse-tags
              filterable
              :clearable="true"
              :popper-append-to-body="false"
              placeholder="请选择媒体"
              style="width: 200px"
              @change="handleChange"
            >
              <el-option v-for="item in filtersData.MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select
              v-model="plan.adAccountIdList"
              multiple
              collapse-tags
              filterable
              :clearable="true"
              :popper-append-to-body="false"
              placeholder="请选择账号"
              style="width: 200px"
              @change="handleChange"
            >
              <el-option v-for="item in filtersData.MEDIA_ACCOUNTS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select
              v-model="plan.designerIds"
              multiple
              collapse-tags
              filterable
              :clearable="true"
              :popper-append-to-body="false"
              placeholder="请选择人员"
              style="width: 200px"
              @change="handleChange"
            >
              <el-option
                multiple
                collapse-tags
                filterable
                v-for="item in filtersData.PTOM_USERS"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-input
              v-model.trim="plan.planName"
              clearable
              placeholder="请输入计划名称"
              style="width: 180px"
              @keyup.native.enter="search"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template v-if="title === '素材选择'">
        <el-form inline>
          <el-form-item>
            <el-select
              v-model="image.gameGroupIds"
              multiple
              collapse-tags
              filterable
              :clearable="true"
              placeholder="请选择应用组"
              style="width: 200px"
              @change="handleChange"
            >
              <el-option
                multiple
                collapse-tags
                filterable
                v-for="item in filtersData.GAME_GROUPS"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            ><el-select
              v-model="image.gameIds"
              multiple
              collapse-tags
              filterable
              :clearable="true"
              placeholder="请选择应用"
              style="width: 200px"
              @change="handleChange"
            >
              <el-option
                multiple
                collapse-tags
                filterable
                v-for="item in filtersData.GAMES"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option> </el-select
          ></el-form-item>
          <el-form-item
            ><el-select
              v-model="image.designerIds"
              multiple
              collapse-tags
              filterable
              :clearable="true"
              placeholder="请选择人员"
              style="width: 200px"
              @change="handleChange"
            >
              <el-option
                multiple
                collapse-tags
                filterable
                v-for="item in filtersData.PTOM_USERS"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option> </el-select
          ></el-form-item>
          <el-form-item>
            <el-input
              v-model.trim="image.imageName"
              clearable
              placeholder="请输入素材名称"
              style="width: 180px"
              @keyup.native.enter="search"
            />
          </el-form-item>
          <el-form-item> <el-button type="primary" @click="search">查询</el-button> </el-form-item>
        </el-form>
      </template>
    </div>
    <TableSelectionPanel
      ref="tablePanelRef"
      :loading="loading"
      :table-data="tableData"
      :result="result"
      @table-row-select="onTableRowSelect"
      @table-select-all="onTableSelectAll"
      @clear-all="clearAll"
      @close-item="onResItemRemove"
    >
      <el-table-column :label="title === '计划选择' ? '计划名称' : '素材名称'">
        <template slot-scope="{ row }">
          <el-tooltip class="item" effect="dark" :content="row.name" placement="top-start">
            <span>{{ row.name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
    </TableSelectionPanel>

    <el-pagination
      :total="total"
      :current-page.sync="pageIndex"
      :page-size.sync="pageSize"
      :page-sizes="[10, 40, 100]"
      layout="total, sizes, prev, pager, next"
      @current-change="changePageIndex"
      @size-change="changePageSize"
      class="pager"
      background
    />
  </div>
</template>
<script setup>
import { ref, toRefs, defineProps, defineExpose, defineEmits } from 'vue'
import { useFilterDialogState } from './hooks/useFilterDialogState'
import { useTableSelectionPanel } from '@/components/table-selection-panel/hooks/useSelection.js'
import { useFilterDialogQuery } from './hooks/useFilterDialogQuery'
import TableSelectionPanel from '@/components/table-selection-panel/index.vue'

const props = defineProps({
  filtersData: {
    type: Object
  },
  title: {
    type: String
  },
  backPlan: {
    type: Array
  },
  backImage: {
    type: Array
  }
})

defineEmits([])

const { filtersData, title } = toRefs(props)

const { plan, image, pageSize, pageIndex, tableData, total, result, loading } = useFilterDialogState(props)

const { tablePanelRef, restoreSelection, onTableRowSelect, onTableSelectAll, onResItemRemove, clearAll, getSelectData } =
  useTableSelectionPanel({
    result,
    tableData
  })

const { getData, search, changePageIndex, changePageSize, handleChange } = useFilterDialogQuery({
  props,
  plan,
  image,
  pageSize,
  pageIndex,
  tableData,
  total,
  loading,
  restoreSelection
})

defineExpose({
  getData,
  getSelectData
})
</script>
<style lang="scss" scoped></style>
